import { BadgeCheck } from "lucide-react";

export function VerifiedBadge({ size = 14, className = "", testId }) {
  return (
    <span
      className={"inline-flex items-center " + className}
      title="Negocio verificado"
      aria-label="Negocio verificado"
      data-testid={testId}
      style={{
        color: "var(--accent)",
        filter: "drop-shadow(0 0 4px var(--accent-glow))",
      }}
    >
      <BadgeCheck size={size} strokeWidth={2.5} />
    </span>
  );
}
